'use strict';

var LocalStorageStateSource = require('./localStorage');
var registerStateSource = require('../core/registerStateSource');

module.exports = function (marty) {
  registerStateSource(marty, 'LocalStorageStateSource', 'localStorage', LocalStorageStateSource);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty-lib/modules/local-storage-state-source/index.js
 ** module id = 573
 ** module chunks = 0
 **/